import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../constants'
import TrackingService from '../../Services/Tracking'
import fetchApiError from '../../Helpers/fetchApiError'
import FreightCard from './FreightCard'
import InfoCard from './InfoCard'
import './styles.scss'

import roadFreight from '../../Assets/Images/road-freight.png'
import airFreight from '../../Assets/Images/air-freight.png'
import oceanFreight from '../../Assets/Images/ocean-freight.png'

import CustomButton from '../../Components/CustomButton'
import AccordionGroup from '../../Components/AccordionGroup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import ServiceCard from './ServiceCard'

import gridImg1 from '../../Assets/Images/grid-1.jpeg'
import gridImg2 from '../../Assets/Images/cart-1.jpg'
import titleIcon1 from '../../Assets/Images/title-icon-1.png'
import missionIcon from '../../Assets/Images/mission-icon.png'
import vissionIcon from '../../Assets/Images/vision-icon.png'
import OurServiceSection from '../../Components/OurServiceSection'
import UnbeatableSection from '../../Components/UnbeatableSection'
import useInView from '../../Hooks/useInView'

const accordions = [
  {
    title: 'Why Us?',
    content:
      'We provide timely delivery to ensure customer satisfaction. Our delivery and courier services can fit different time and budget sensitivities, and our rates will leave you confident that you have made the right choice.',
    icon: <FontAwesomeIcon className="icon" icon={solid('circle-info')} />,
  },
  {
    title: 'Timely delivery',
    content:
      'When you need it there today and not overnight, your shipment will be picked up and delivered across Maryland or out of state on a direct delivery.',
    icon: <FontAwesomeIcon className="icon" icon={solid('truck')} />,
  },
  {
    title: 'Warehousing Solution',
    content:
      'Falcon warehouses have immediate availability, are climate-controlled and are protected with 24-hour security. Your inventory can be available for shipment from any of our warehouses around the clock, and our professional customer service staff is always on site for immediate retrieval and preparation for urgent delivery.',
    icon: <FontAwesomeIcon className="icon" icon={solid('plane-up')} />,
  },
]

const stats = [
  { num: '350+', label: 'Destinations' },
  { num: '1993', label: 'Established' },
  { num: '24/7', label: 'Support' },
  { num: '99%', label: 'On-Time Delivery' },
]

const Home = () => {
  const navigate = useNavigate()
  const [statsRef, statsInView] = useInView(0.2)
  const [sectionRef, sectionInView] = useInView(0.1)

  const [trackingNumber, setTrackingNumber] = useState('')
  const [trackingLoading, setTrackingLoading] = useState(false)
  const [trackingError, setTrackingError] = useState(null)

  const handleHeroTrack = async (e) => {
    e.preventDefault()
    setTrackingLoading(true)
    setTrackingError(null)
    try {
      const res = await TrackingService.get_by_tracking_number(trackingNumber)
      navigate(ROUTES.trackIt, { state: { result: res.data.data } })
    } catch (error) {
      setTrackingError(fetchApiError(error))
      setTrackingLoading(false)
    }
  }

  const navigateToAboutUs = () => navigate(ROUTES.about)

  const goToServices = (service) => () => {
    navigate(ROUTES.services, { state: { service } })
  }

  return (
    <div className="home-page">
      <div className="home-page__top" style={{ backgroundImage: "url('/images/home-slide-2.jpeg')" }}>
        <div className="home-page__top__overlay" />

        <InfoCard
          text={'Making\nTransportation\nFast & Safe'}
          onClick={() => navigate(ROUTES.about)}
          btnLabel="About Us"
        >
          <form className="hero-tracker" onSubmit={handleHeroTrack}>
            <div className="hero-tracker__input-wrap">
              <FontAwesomeIcon icon={solid('magnifying-glass')} className="hero-tracker__icon" />
              <input
                type="text"
                className="hero-tracker__input"
                placeholder="Enter tracking number..."
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="hero-tracker__btn" disabled={trackingLoading}>
              {trackingLoading ? 'Tracking...' : 'Track Shipment'}
            </button>
            {trackingError && <p className="hero-tracker__error">{trackingError}</p>}
          </form>
        </InfoCard>

        <div className="home-page__top__freights">
          <FreightCard
            src={roadFreight}
            title="Road Freight"
            content="Easy to Use and Customer Focused"
            onClick={goToServices('Ocean Freight')}
          />
          <FreightCard
            src={airFreight}
            title="Air Freight"
            content="Air Freight Services with Optional Collection"
            onClick={goToServices('Air Freight')}
          />
          <FreightCard
            src={oceanFreight}
            title="Ocean Freight"
            content="Direct consolidations covering 350 destinations"
            onClick={goToServices('Ocean Freight')}
          />
        </div>
      </div>

      <div ref={statsRef} className={`home-page__stats${statsInView ? ' in-view' : ''}`}>
        {stats.map((s, i) => (
          <>
            <div key={s.num} className="home-page__stats__item">
              <span className="home-page__stats__item__num">{s.num}</span>
              <span className="home-page__stats__item__label">{s.label}</span>
            </div>
            {i < stats.length - 1 && (
              <div key={`div-${i}`} className="home-page__stats__divider" />
            )}
          </>
        ))}
      </div>

      <div className="home-page__content">
        <section>
          <FreightCard
            src={roadFreight}
            title="Road Freight"
            content="Easy to Use and Customer Focused"
            onClick={goToServices('Ocean Freight')}
          />
          <FreightCard
            src={airFreight}
            title="Air Freight"
            content="Air Freight Services with Optional Collection"
            onClick={goToServices('Air Freight')}
          />
          <FreightCard
            src={oceanFreight}
            title="Ocean Freight"
            content="Direct consolidations covering 350 destinations"
            onClick={goToServices('Ocean Freight')}
          />
        </section>

        <section ref={sectionRef} className={sectionInView ? 'in-view' : ''}>
          <div className="section1-col">
            <span className="title-text">
              <img src={titleIcon1} alt="" />
              Who We Are?
            </span>

            <p>
              We're one of the leading independent shipping and logistics
              providers. Trusted since 1993 by some of the world's leading
              companies, we provide liner and port agency services, freight
              forwarding by sea, air and...
            </p>

            <CustomButton
              label={'Read More'}
              otherClassName="read-more"
              onClick={navigateToAboutUs}
            />

            <div className="accordion-container">
              <AccordionGroup data={accordions} />
            </div>
          </div>

          <div className="section1-col">
            <div>
              <img src={gridImg1} alt="" />
            </div>

            <ServiceCard
              title="Mission"
              content="To offer high-performance solutions that would exceed customer expectations through high quality service..."
              icon={<img src={missionIcon} />}
            />

            <ServiceCard
              title="Vision"
              content="To surpass customer expectations through Innovation, Creativity and Quality..."
              icon={<img src={vissionIcon} />}
            />

            <div>
              <img src={gridImg2} alt="" />
            </div>
          </div>
        </section>

        <UnbeatableSection />

        <OurServiceSection />
      </div>
    </div>
  )
}

export default Home
